import { isNil } from 'lodash';

import DataDogLogs from 'utils/DataDogLogs';

const SessionStorage = class {
  static getSessionStorageItem(key, options = {}) {
    try {
      const serializedValue = window.sessionStorage.getItem(key);

      if (isNil(serializedValue)) {
        return null;
      }

      return JSON.parse(serializedValue);
    } catch (e) {
      DataDogLogs.error(
        'SessionStorage:_getStorage - Encountered an error',
        options.loggingContext,
        e
      );

      return null;
    }
  }

  static setSessionStorageItem(key, value, options = {}) {
    try {
      const serializedValue = JSON.stringify(value);

      window.sessionStorage.setItem(key, serializedValue);
    } catch (e) {
      DataDogLogs.error(
        'SessionStorage:_setStorage - Encountered an error',
        options?.loggingContext,
        e
      );
    }
  }
};

export default SessionStorage;
